module.exports = __webpack_public_path__ + "media/images/client-31-e36650549b0181035fcc5496753fa92e.png";